import { render, staticRenderFns } from "./ForestersCanadaCE-FR.vue?vue&type=template&id=44d10f7b&scoped=true"
import script from "./ForestersCanadaCE-FR.vue?vue&type=script&lang=js"
export * from "./ForestersCanadaCE-FR.vue?vue&type=script&lang=js"
import style0 from "./ForestersCanadaCE-FR.vue?vue&type=style&index=0&id=44d10f7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d10f7b",
  null
  
)

export default component.exports